import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit,faTrashAlt,faUser, faArrowRight ,faTools ,faPlus } from '@fortawesome/free-solid-svg-icons';
import Header from "../Header";
import "./index.css";

const Users = () => {
  const tableRef = useRef(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);  

  // Fetch User Data
  useEffect(() => {
    const mgrId = localStorage.getItem("userId");

    if (!mgrId) {
      setError("User ID not found in localStorage.");
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/user/${mgrId}`);
        if (!response.ok) throw new Error("Network response was not ok");

        const userData = await response.json();
        const updatedUsers = userData.map(user => {
          const { renewal_date } = user; // Assuming renewal_date is a property of the user object
          if (renewal_date) {
            const today = new Date();
            const renewalDate = new Date(renewal_date);
    
            // Ensure the renewal date is valid
            if (isNaN(renewalDate)) {
              console.error('Invalid renewal date for user:', user);
              return user; // Skip invalid renewal date
            }
    
            const timeDifference = renewalDate - today;
            const daysDifference = timeDifference / (1000 * 3600 * 24); // Convert ms to days
    
            // Check if renewal is within the next 5 days
            if (daysDifference <= 5 && daysDifference > 0) {
              user.showReminder = true; // Add a showReminder flag to the user object
            } else {
              user.showReminder = false;
            }
          } else {
            user.showReminder = false; // If no renewal_date, set to false
          }
          return user;
        });
    
        // Update state with the updated user data
        setUserData(updatedUsers);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); 

  // Initialize DataTable after user data is fetched
  useEffect(() => {
    if (userData?.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [userData]);

  const handleRenwal = async (userId, actionType) => {
    try {
      // Ensure userId and actionType are valid
      if (!userId || !actionType) {
        console.error('Invalid userId or actionType');
        return;
      }
  
      // Construct the URL correctly
      const url = `https://apiaksharaconnect.aksharafinalytics.in/testmail/${userId}/${actionType}`;
  
      // Send GET request to the API (instead of POST)
      const response = await fetch(url, {
        method: 'GET',  // Change to GET since the API route expects a GET request
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      // Handle response errors
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response:", errorData);
        throw new Error(`Network response was not ok. Status: ${response.status}`);
      }
  
      const data = await response.json();
  
      // Handle success
      setSuccessMessage(`${actionType} sent successfully!`);
    } catch (error) {
      console.error('Error occurred:', error);
     //setErrorMessage('Something went wrong. Please try again.');
    }
  }; 

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>User Details</h4>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}
            {successMessage && <div className="alert alert-success">{successMessage}</div>}
            {/* Display User Data if Available */}
            {userData ? (
              <div className="table-responsive">
                <table
                  ref={tableRef}
                  className="table table-striped table-bordered display nowrap"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>S.no</th>
                      <th>User</th>
                      <th>Email</th>
                      <th>Phone</th>
                      {/* <th>Plan</th>
                      <th>Payment Status</th> */}
                      <th>Service</th>
                      {/* <th>Reminder</th> */}
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData?.length > 0 ? (
                      userData.map((user, index) => (
                        <tr key={user.id || index}>
                          <td>{index + 1}</td>
                          <td>
                            <a href={`/userinfo/${user.id}`} className="text-decoration-none">
                              {user.company || 'N/A'}
                            </a>
                          </td>
                          <td>{user.email}</td>
                          <td>{user.phone}</td>
                          {/* <td>{user.planName}</td>
                          <td>{user.paymentstatus}</td> */}
                          <td>
                            <a className="btn btn-success ms-2 p-1 m-1 text-decoration-none" href={`/UserAddServices/${user.id}`} title='Add Another Service'>
                              <FontAwesomeIcon icon={faTools }  />&nbsp;
                              <FontAwesomeIcon icon={faPlus}  /> 
                            </a>
                          </td>
                          {/* <td>
                      {user.showReminder  ? (
                          <button className="btn btn-primary p-1 m-1" onClick={() => handleRenwal(user.id, 'Renwal')} title="Renwal">
                            Renwal
                          </button>
                        ) : (
                          ' '
                        )}
                        {user.due > 0 ? (
                          <button className="btn btn-secondary p-1 m-1"onClick={() => handleRenwal(user.id, 'Payment')} title="Payment">
                            Payment
                          </button>
                          ) : (
                            ' '
                          )}
                      </td> */}
                          <td>{user.date}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No record found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="alert alert-warning">No user data available</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
